export default __webpack_public_path__ + "81826cd66f420cf9d43b3c8bfe9ee97a.svg";